export enum MessageType {
  JOIN_USER = 'JOIN_USER/3.0',
  LEAVE_USER = 'LEAVE_USER/3.0',
  END_LIVE = 'END_LIVE/3.0',
  SEND_NICE = 'SEND_NICE/3.0',
  SEND_MESSAGE = 'SEND_MESSAGE/3.0',
  SEND_GIFT = 'SEND_GIFT/3.0',
  MUTE = 'START_MUTE/3.0',
  UN_MUTE = 'END_MUTE/3.0',
  FOLLOW_USER = 'FOLLOW_USER/3.0',
  NOTIFY_BOARD = 'NOTIFY_BOARD/3.0',
  NOTIFY_BERRY_COIN = 'NOTIFY_BERRY_COIN/3.0',
  NOTIFY_SCORE = 'NOTIFY_SCORE/3.0',
  NOTIFY_LIVER_LEVEL_UP = 'NOTIFY_LIVER_LEVEL/3.0',
  GIFT_TOP = 'NOTIFY_GIFTTOP_AUDIENCE/3.0',
  MIRRORING = 'START_MIRROR/3.0',
  UN_MIRRORING = 'END_MIRROR/3.0',
  PUBLISH_LIVE = 'PUBLISH_LIVE/3.0',
  PRIVATE_LIVE = 'PRIVATE_LIVE/3.0',
  START_ACCEPTING_PAIR = 'START_ACCEPTING_PAIR/3.0',
  END_ACCEPTING_PAIR = 'END_ACCEPTING_PAIR/3.0',
  START_PAIR_REQUEST = 'START_PAIR_REQUEST/3.0',
  END_PAIR_REQUEST = 'END_PAIR_REQUEST/3.0',
  START_PAIR = 'START_PAIR/3.0',
  END_PAIR = 'END_PAIR/3.0',
  REQUEST_LIVE_MATCH = 'REQUEST_LIVE_MATCH/3.0',
  MATCH_REQUEST = 'MATCH_REQUEST/3.0',
  REJECT_LIVE_MATCH = 'REJECT_LIVE_MATCH/3.0',
  START_LIVE_MATCH = 'START_LIVE_MATCH/3.0',
  END_LIVE_MATCH = 'END_LIVE_MATCH/3.0',
  START_LIVE_COMPETITION = 'START_LIVE_COMPETITION/3.0',
  END_LIVE_COMPETITION = 'END_LIVE_COMPETITION/3.0',
  NOTIFY_LIVE_COMPETITION_SCORE = 'NOTIFY_LIVE_COMPETITION_SCORE/3.0',
  NOTIFY_LIVE_MATCH_MUTE_ON = 'NOTIFY_LIVE_MATCH_MUTE_ON/3.0',
  NOTIFY_LIVE_MATCH_MUTE_OFF = 'NOTIFY_LIVE_MATCH_MUTE_OFF/3.0',
  NOTIFY_EVENT_RANKING = 'NOTIFY_EVENT_RANKING/3.0',
}
